import { ItineraryRepository } from '~/passporter-services/itinerary/repository'
import { mediaCache } from '~/passporter-services/media/cache'
import { WallPinRepository } from '~/services/trip/wallPin/repository'

export function clearAllCaches(): void {
	ItineraryRepository.clearCaches()
	WallPinRepository.clearCaches()
	mediaCache.clear()
}
